import { AlertCircle } from "lucide-react"

const InfoNotice = ({ mesActual, añoActual }) => {
  return (
    <div
      style={{
        display: "flex",
        gap: "12px",
        alignItems: "flex-start",
        padding: "14px 16px",
        backgroundColor: "#fff8f0",
        border: "1px solid #DBC5A8",
        borderLeft: "4px solid #003226",
        borderRadius: "8px",
        marginTop: "12px",
      }}
    >
      <AlertCircle size={18} color="#003226" style={{ flexShrink: 0, marginTop: "2px" }} />
      <p style={{ margin: 0, fontSize: "13px", color: "#444", lineHeight: "1.6" }}>
        <strong>Importante:</strong> el valor ingresado debe corresponder al precio de referencia
        del vehículo según InfoAuto vigente para{" "}
        <strong>
          {mesActual} de {añoActual}
        </strong>
        . La simulación puede estar sujeta a verificación y aprobación crediticia.
      </p>
    </div>
  )
}

export default InfoNotice
